

































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class LoginForm extends Vue {

  @Prop()
  errorMessage!: string

  @Prop({ default: false })
  loading!: boolean

  tab = 0

  /** User's login details */
  user = {
    email: null,
    password: null
  }

  /** If the user's password should be visible */
  showpass = false

  /** Emit event with form data */
  submit() {
    this.$emit('submit', { ...this.user, type: this.tab ? 'employer' : 'user' })
  }
}

